export const DEFAULT_LOCALE = 'en-US'
export const DEFAULT_TENANT = 'vistaprint'
export const NATIONAL_PEN_TENANT = 'national-pen'
export const HEADER_CONTENTFUL_ID = 'Vistaprint Site Header'
export const HEADER_ANZS_CONTENTFUL_ID = 'Vistaprint Site Headers'
export const FOOTER_CONTENTFUL_ID = '7M7XqBiJrb4R1lgqUU9zNV'
export const FOOTER_EU_CONTENTFUL_ID = '5JMKnX60TyLpEsstIbO6O3'
export const FOOTER_IN_CONTENTFUL_ID = '28zDBmoQQD947T2EAeeQql'
export const FOOTER_ANZS_CONTENTFUL_ID = '5JMKnX60TyLpEsstIbO6O3'

export const EU_LOCALES: ReadonlySet<string> = new Set([
  'fr-fr',
  'de-de',
  'en-gb',
  'it-it',
  'nl-nl',
  'es-es',
  'pt-pt',
  'nb-no',
  'nl-be',
  'fr-be',
  'de-at',
  'en-ie',
  'it-ch',
  'fr-ch',
  'de-ch',
  'sv-se',
  'da-dk',
  'fi-fi',
])
export const IN_LOCALES: ReadonlySet<string> = new Set(['en-in'])
export const ANZS_LOCALES: ReadonlySet<string> = new Set(['en-au', 'en-nz', 'en-sg'])
export const HEADER_WIX_CONTENTFUL_ID = 'Wix Site Header'
export const FOOTER_WIX_CONTENTFUL_ID = 'Wix Site Footer'
export const NATIONAL_PEN_FOOTER_CONTENTFUL_ID = '3MgNjeMspLZEHTVeFpwYly'
export const NATIONAL_PEN_HEADER_CONTENTFUL_ID = 'National Pen Header'
export const HEADER_CONTENTFUL_TYPE = 'siteHeader'
export const FOOTER_CONTENTFUL_TYPE = 'siteFooter'
export const DEFAULT_REQUESTOR = 'bookends-browser'
// API Key is meant to be public (supplied by CCM team, no rotation, not a real secret)
export const CARE_API_KEY = ['7fRc0sClU834UWbWTa7nT1hEM6muxldT', '179sQCWb'].join('')
export const CARE_PHONE_URL = 'https://global-channel-provider-service.care.vpsvc.com/v3/channels/phone/params'
export const DEFAULT_CACHE_TTL = 900 // stdTTL: 15 mins, It sets the default time in seconds for each cached item to live before it expires.
export const DEFAULT_CACHE_CHECK_PERIOD = 1200 // check period: 20 mins, It determines how often the cache performs a cleanup operation to remove expired items.

// NOTE: The tenant's Profile Service account ID now comes from the Experience API
// via TenantConfig.accountId. The hardcoded value below is retained only as a
// fallback in useAuth when TenantConfig is unavailable.
export const CLAIM_CANONICAL_ID = 'https://claims.cimpress.io/canonical_id'
export const CLAIM_CIMPRESS_INTERNAL = 'https://claims.cimpress.io/cimpress_internal'

// navigation
export const NAVIGATION_SERVICE_BASE_URL = 'https://bookends-backend-service.prod.mcx.vpsvc.com/navigation'
export const NAVIGATION_SERVICE_CDN_URL = 'https://cdn-bookends-backend-service.prod.mcx.vpsvc.com/navigation'
export const NAVIGATION_CONTEXT_URL = 'https://bookends-source.prod.merch.vpsvc.com/v3/context.json?requestor=bookends-v2'
export const MAX_THIRD_LEVEL_ITEMS = 10

// brand pillars - fetched from Contentful via MCS using fragmentSlimBanner content type
// Tenant/locale eligibility is determined by MCS placement ('All Pages' / 'Above Footer');
// no hardcoded tenant gate.
export const SLIM_BANNER_CONTENTFUL_TYPE = 'fragmentSlimBanner'

/** TTL for brand pillars MCS response cache (30 mins) */
export const BRAND_PILLARS_CACHE_TTL_SECONDS = 30 * 60

/** Number of columns in the desktop flyout layout */
export const NUM_COLUMNS = 6

/** Maximum number of MX merchandising columns in the flyout */
export const MX_SECTION_MAX_COLUMNS = 3

/** Fallback account ID when TenantConfig is unavailable (VistaPrint default) */
export const FALLBACK_ACCOUNT_ID = 'ozoDdrmewShEcbUDWX8J3V'
